import * as React from "react";
import { useSelector } from "react-redux";
import {
  DashboardMenuItem,
  MenuItemLink,
  useResourceDefinitions,
  useSidebarState,
} from "react-admin";

import DashboardIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import ComposeIcon from "@mui/icons-material/Schema";
import DeveloperIcon from "@mui/icons-material/DeveloperMode";
import CatalogIcon from "@mui/icons-material/LibraryBooks";
import ConfigIcon from "@mui/icons-material/Settings";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssessmentIcon from "@mui/icons-material/Assessment";
import InsightsIcon from "@mui/icons-material/Lightbulb";
import TvIcon from "@mui/icons-material/Tv";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import AppExtensionProviderRegistry, {
  AppExtension,
} from "../../framework/app/app.extension.provider";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

interface NeoMenuProps {
  onMenuClick?: () => void;
  logout?: () => void;
  hideWelcome?: boolean;
}

const NeoMenu = ({ onMenuClick, logout, hideWelcome }: NeoMenuProps) => {
  const excludedResources = [
    "theme",
    "environment",
    "dashboard",
    "category",
    "item",
  ];

  const resources = useResourceDefinitions();
  const [open, setOpen] = useSidebarState();
  const handleMenuClick = () => {
    onMenuClick?.(); // Call original if it exists
    setOpen(false);   // Close sidebar
  };
  const allResourcecs = Object.keys(resources);
  const tenant = sessionStorage.getItem("current-tenant");
  const brand = sessionStorage.getItem("current-brand");
  const navigate = useNavigate();
  const location = useLocation();
  const appExtension: AppExtension =
    AppExtensionProviderRegistry.getDefaultProvider()?.getAppExtension();
  const defaultRoute = appExtension.getDefaultRoute();

  const ResourceSubMenuItem = ({ resourceName, onClick }) => {
    const resources = useResourceDefinitions();
    const resource = resources[resourceName];

    if (!resource) {
      return null; // If the resource doesn't exist, don't render anything
    }

    return (
      <SubMenuItem
        to={`/${resourceName}`}
        label={resource?.options?.label || resourceName}
        Icon={resource?.icon || React.Fragment} // Use a default icon if none is provided
        onClick={onClick}
      />
    );
  };

  const SubMenuItem = ({
    to,
    label,
    Icon,
    onClick,
    padding = 32,
    fontSize = "0.875rem",
  }) => (
    <MenuItemLink
      to={to}
      primaryText={label}
      leftIcon={<Icon style={{ fontSize: "20px" }} />} // Smaller icon
      onClick={onClick}
      style={{
        paddingLeft: `${padding}px`,
        fontSize: fontSize,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    />
  );

  return (
    <div>
      {!hideWelcome && (
        <MenuItemLink to="/" primaryText="Welcome" leftIcon={<DashboardIcon />} />
      )}

      {/* Disabled Analytics */}
      <ListItem
        disabled
        sx={{
          opacity: 0.3,
          cursor: 'not-allowed',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'text.disabled' }}>
          {resources["analytics"]?.icon ? (
            React.createElement(resources["analytics"]?.icon)
          ) : (
            <CategoryIcon />
          )}
        </ListItemIcon>
        <ListItemText
          primary={
            (resources["analytics"]?.options &&
              resources["analytics"]?.options?.label) ||
            "Analytics"
          }
          sx={{ color: 'text.disabled' }}
        />
      </ListItem>

      <MenuItemLink
        to="/reports"
        primaryText="Reports"
        leftIcon={<AssessmentIcon />}
        onClick={handleMenuClick}
      />
      
      {/* Disabled Marketplace */}
      <ListItem
        disabled
        sx={{
          opacity: 0.3,
          cursor: 'not-allowed',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'text.disabled' }}>
          <ComposeIcon />
        </ListItemIcon>
        <ListItemText primary="Marketplace" sx={{ color: 'text.disabled' }} />
      </ListItem>
      
      {/* Disabled Menu Management */}
      <ListItem
        disabled
        sx={{
          opacity: 0.3,
          cursor: 'not-allowed',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'text.disabled' }}>
          <CatalogIcon />
        </ListItemIcon>
        <ListItemText primary="Menu Management" sx={{ color: 'text.disabled' }} />
      </ListItem>
      
      {/* Disabled Insights Menu */}
      <ListItem
        disabled
        sx={{
          opacity: 0.3,
          cursor: 'not-allowed',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'text.disabled' }}>
          <InsightsIcon />
        </ListItemIcon>
        <ListItemText primary="Insights" sx={{ color: 'text.disabled' }} />
        <ExpandMoreIcon sx={{ color: 'text.disabled' }} />
      </ListItem>
      
      {/* Disabled Configuration Menu */}
      <ListItem
        disabled
        sx={{
          opacity: 0.3,
          cursor: 'not-allowed',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'text.disabled' }}>
          <ConfigIcon />
        </ListItemIcon>
        <ListItemText primary="Store Configuration" sx={{ color: 'text.disabled' }} />
        <ExpandMoreIcon sx={{ color: 'text.disabled' }} />
      </ListItem>

      {logout}
    </div>
  );
};

export default NeoMenu;

/*
       {Object.keys(resources).filter(name => !excludedResources.includes(name)).map(name => (
                  <MenuItemLink
                      key={name}
                      to={`/${name}`}
                      primaryText={(resources[name].options && resources[name].options.label) || name}
                      leftIcon={resources[name].icon ? React.createElement(resources[name].icon) : <CategoryIcon />}
                      onClick={handleMenuClick}
                  />
              ))}


               {/** 
      <MenuItemLink
        key={"tenant"}
        to={`/tenant`}
        primaryText={
          (resources["tenant"]?.options &&
            resources["tenant"]?.options?.label) ||
          "tenant"
        }
        leftIcon={
          resources["tenant"]?.icon ? (
            React.createElement(resources["tenant"]?.icon)
          ) : (
            <CategoryIcon />
          )
        }
        onClick={handleMenuClick}
      />
      <MenuItemLink
        key={"brand"}
        to={`/brand`}
        primaryText={
          (resources["brand"]?.options && resources["brand"]?.options?.label) ||
          "brand"
        }
        leftIcon={
          resources["brand"]?.icon ? (
            React.createElement(resources["brand"]?.icon)
          ) : (
            <CategoryIcon />
          )
        }
        onClick={handleMenuClick}
      />
                  */
